export default __webpack_public_path__ + "static/media/meridional.76f444c1.png";